import { useRef, useEffect, useState } from "react";
import IMGGR1 from "../../assets/images/home/gr1.jpg";
import IMGGR2 from "../../assets/images/home/gr2.jpg";
import IMGGR3 from "../../assets/images/home/gr3.jpg";
import IMGGR4 from "../../assets/images/home/gr4.jpeg";
import IMGGR5 from "../../assets/images/home/gr5.jpg";
import IMGGR6 from "../../assets/images/home/gr6.webp";
import { useSelector } from "react-redux";
import AboutUs from "../../assets/images/home/aboutus.png";
import "./card.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { SliderComp } from "../../components/slider";
import Modal from "../../components/Modal";
import {
  LinearProgress,
  Checkbox,
  Radio,
  useScrollTrigger,
} from "@mui/material";
import { axios } from "../../utils/axios";
import DirectionsMapComp from "../../components/DirectionsMap";
import MapSearch from "../../components/LocationSearchByGoogle";
import { useLocation, useNavigate } from "react-router-dom";
import TripModal from "../../components/TripModel";
import SearchIcon from "@mui/icons-material/Search";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutSubscriptionForm from "../../components/stripSubscription.jsx";
import { loadStripe } from "@stripe/stripe-js";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { format, addDays, addMonths } from "date-fns";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner/index.jsx";

export default function Home() {
  const navigate = useNavigate();
  //----------------------- strip------------------------------

  //---------------------
  const questionnairesRef = useRef(null);
  const [openftrip, setOpenFTrip] = useState(false);
  const [selectedFtrip, setSelectedFTrip] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [popData, setPopData] = useState();
  const [qindex, setQindex] = useState(0);
  const [progress, setProgress] = useState(10);
  const location = useLocation();
  const [plans, setPlans] = useState([]);
  const [center, setCenter] = useState({
    lat: 31.06339829204645,
    lng: -97.82153183960645,
    load: false,
  });
  const [selectedOptions, setSelectedOptions] = useState({});
  const authToken = useSelector((state) => state.auth.token);
  const [pins, setPins] = useState();
  const [featuredtrips, setFeaturedTrips] = useState([]);
  const [mapZoom, setMapZoom] = useState(14);
  const [allTags, setAllTags] = useState([]);
  const [expandtags, setExpandTags] = useState(false);
  const [expandCategories, setExpandCategories] = useState(false);
  const [loader, setLoader] = useState(false);
  const [subOpen, setSubOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [featuredhotels, setFeaturedHotels] = useState([]);
  const [stripePromise, setStripePromise] = useState(null);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [btnloder, setBtnLoader] = useState(false);
  const [placeId, setPlaceId] = useState("");
  const toggleHeight = () => {
    setExpanded((prev) => !prev);
  };
  const { tags } = useSelector((state) => state.pins);
  const [occupancy, setOccupancy] = useState({
    rooms: 1,
    adults: 2,
    children: [],
  });
  useEffect(() => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY));
    getFeaturedHotels();
    axios
      .get(process.env.REACT_APP_BACKEND + "pins/getalltags")
      .then((resp) => {
        setAllTags(resp.data.data);
      })
      .catch((err) => console.log(err));
  }, [tags]);
  const handleOpenQuestionsPopUp = (data) => {
    setPopData(data);
    setOpenPopUp(true);
  };

  const getFeaturedHotels = () => {
    axios
      .post(process.env.REACT_APP_BACKEND + "featuredhotels/getfeaturedhotels")
      .then((resp) => {
        let data = resp?.data?.data.docs;
        data = data.map((item) => ({
          id: item?._id,
          image: item?.heroImage,
          name: item?.name,
          descp: item?.description,
          hid: item?.hotelId,
        }));
        setFeaturedHotels(data);
      })
      .catch((err) => console.log(err));
  };
  const handleClose = () => {
    setOpenPopUp(false);
    setSelectedFTrip(null);
    setOpenFTrip(false);
    setProgress(10);
    setQindex(0);
  };

  const handleNext = (qindex) => {
    setQindex((prevIndex) => {
      const newIndex = Math.min(prevIndex + 1, questions.length - 1);
      setProgress(((newIndex + 1) / questions.length) * 100);

      return newIndex;
    });
    if (qindex === questions.length - 1) {
      handleClose(); // Call the close function
      setQindex(0);
      setPopData();
    }
  };

  const handleBack = () => {
    setQindex((prevIndex) => {
      const newIndex = Math.max(prevIndex - 1, 0);
      setProgress(((newIndex + 1) / questions.length) * 100);
      return newIndex;
    });
  };
  const questionBody = () => {
    return (
      <>
        <div className="row mt-2">
          <div className="col-md-4 px-4 ">
            <h2 className="my-2">{popData?.title}</h2>
            <div className="w100">
              <img
                className="imgclass"
                src={IMGGR1}
                style={{ borderRadius: "8px" }}
                loading="lazy"
                alt=""
              />
            </div>
            <p style={{ textAlign: "justify" }}>{popData?.backContent}</p>
          </div>
          <div className="col-md-8 px-4 py-2">
            <h1>Discover Your Ideal Trip</h1>

            <h4 className="mb-3">{questions[qindex]?.question}</h4>
            <LinearProgress variant="determinate" value={progress} />
            <div className="mt-3">
              {questions[qindex]?.answers.map((ansData, index) => (
                <div className="d-flex align-items-center mt-3" key={index}>
                  {[4, 5, 6].includes(questions[qindex].id) ? (
                    <Radio
                      checked={
                        selectedOptions[questions[qindex].id]?.includes(
                          index
                        ) || false
                      }
                      onChange={() => handleChange(index, questions[qindex].id)}
                    />
                  ) : (
                    <Checkbox
                      checked={
                        selectedOptions[questions[qindex].id]?.includes(
                          index
                        ) || false
                      }
                      onChange={() => handleChange(index, questions[qindex].id)}
                    />
                  )}
                  <p className="ms-2">{ansData.option}</p>
                </div>
              ))}
            </div>

            <div className="d-flex align-items-center justify-content-between mt-4">
              <button
                className="btn-outlined"
                onClick={handleBack}
                disabled={qindex === 0}
              >
                Back
              </button>
              <button
                className="btn-contained"
                onClick={() => handleNext(qindex)}
                // disabled={qindex === questions.length - 1}
              >
                {qindex === questions.length - 1 ? "Submit" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };
  const handleChange = (optionIndex, questionId) => {
    const isRadio = [4, 5, 6].includes(questionId); // Check if question should use Radio

    setSelectedOptions((prev) => {
      const currentSelections = prev[questionId] || [];

      if (isRadio) {
        return { ...prev, [questionId]: [optionIndex] };
      } else {
        if (currentSelections.includes(optionIndex)) {
          return {
            ...prev,
            [questionId]: currentSelections.filter(
              (index) => index !== optionIndex
            ),
          };
        } else if (currentSelections.length < 2) {
          return { ...prev, [questionId]: [...currentSelections, optionIndex] };
        } else {
          // Limit reached, no changes made
          return prev;
        }
      }
    });
  };
  const handlePlaceSelect = (lat, lng) => {
    setCenter({ lat, lng, load: true });
  };
  useEffect(() => {
    getAllMapPins();
    getLocation();
    getPlans();
    getFeaturedTrips();
  }, []);
  const getAllMapPins = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND}pins/getpins`
      );
      setPins(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching map pins:", error);
    }
  };
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCenter({ lat: latitude, lng: longitude, load: false });
        },
        (err) => {
          console.log(err.message);
        }
      );
    } else {
      console.log("Geolocation is not supported by your browser.");
    }
  };
  const getFeaturedTrips = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "featuredtrips/getfeaturedtrips")
      .then((resp) => {
        setFeaturedTrips(resp.data.data);
      })
      .catch((err) => console.log(err));
  };

  const getPlans = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getactivesubscription")
      .then((resp) => {
        setPlans(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // const upgradeSubscription = (val) => {
  //   if (val.activePlan === "notLoggedIn") {
  //     navigate("/signup");
  //   } else if (val?.sessionId) {
  //     setSelectedId(val);
  //     setSubOpen(true);
  //   } else {
  //     setSelectedId(val);
  //     axios
  //       .post(process.env.REACT_APP_BACKEND + "auth/membershipsubscribtion", {
  //         planName: val.value,
  //       })
  //       .then((resp) => {
  //         window.location.href = resp.data.url;
  //       })
  //       .catch((err) => console.log(err));
  //   }
  // };
  const upgradeSubscription = (val) => {
    if (val.activePlan === "notLoggedIn") {
      navigate("/signup");
    } else if (val?.sessionId) {
      setSelectedId(val);
      setSubOpen(true);
    } else {
      setSelectedId(val);
      setBtnLoader(true);
      axios
        .post(process.env.REACT_APP_BACKEND + "auth/membershipsubscribtion", {
          planName: val.value,
        })
        .then((resp) => {
          setClientSecret(resp.data.clientSecret);
          setPaymentOpen(true);
          setBtnLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setBtnLoader(false);
          toast.error("Something went wrong");
        });
    }
  };
  const handleFeaturedTripClick = (item) => {
    setSelectedFTrip(item);
    setOpenFTrip(true);
  };

  const onPaymentSuccess = () => {
    setPaymentOpen(false);
    getPlans();
    toast.success("Subscribed successfully");
  };
  const handleFeatureHotelClick = (item) => {
    const checkinDate = addMonths(addDays(new Date(), 30), 1);
    const checkoutDate = addDays(checkinDate, 1);
    const url = `/hotel?hid=${JSON.stringify(
      item?.hid
    )}&checkin=${JSON.stringify(
      format(checkinDate, "yyyy-MM-dd")
    )}&checkout=${JSON.stringify(
      format(checkoutDate, "yyyy-MM-dd")
    )}&oc=${JSON.stringify(occupancy)}&ds=${true}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const getCategories = async (data) => {
    setLoader(true);
    if (data === "clear") {
      getAllMapPins();
      setLoader(false);
    } else {
      const getUserPins = await getAllMapPins();
      axios
        .post(process.env.REACT_APP_BACKEND + "pins/getpinsbycategories", {
          center: center,
          radius: 1500,
          type: data,
        })
        .then((resp) => {
          setLoader(false);
          if (resp.data.data.length !== 0) {
            setPins((prevPins) => [...getUserPins, ...resp.data.data]);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const cancelSubscription = () => {
    setBtnLoader(true);
    axios
      .get(
        process.env.REACT_APP_BACKEND +
          `auth/subscriptioncancel?session_id=${selectedId.sessionId}`,
        {
          planName: selectedId.value,
        }
      )
      .then((resp) => {
        setSubOpen(false);
        toast.success(resp?.data?.message);
        setBtnLoader(false);
        getPlans();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
      });
  };

  return (
    <div className="bgsearch ">
      {featuredhotels.length > 3 && (
        <>
          {" "}
          <h2 className="pt-4 t-center">Featured Hotels</h2>
          <div className="homecont">
            <SliderComp
              slideNum={4}
              data={featuredhotels}
              autoplay={true}
              autoplaySpeed={3000}
              onItemClick={handleFeatureHotelClick}
            />
          </div>
        </>
      )}
      <h2 className="t-center mt-5">
        <span style={{ color: "var(--primary-color)" }}>Pin</span> activities
      </h2>
      <div
        className="d-flex align-items-center flex-column mb-4 pb-4 "
        style={{ position: "relative" }}
      >
        <div
          style={{
            height: expandtags === true ? "auto" : "25px",
          }}
          className=" mt-4 bxShadow hmap-cont"
        >
          <button
            className="toggle-button w100 fw-600"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginRight: "8px",
            }}
            onClick={() => setExpandTags((prev) => !prev)}
          >
            {expandtags === true ? (
              <div className="d-flex align-items-center  justify-content-center">
                {" "}
                Bucketlist <ArrowUpwardIcon style={{ width: "18px" }} />{" "}
              </div>
            ) : (
              <div
                div
                className="d-flex align-items-center justify-content-center"
              >
                {" "}
                Bucketlist <ArrowDownwardIcon style={{ width: "18px" }} />{" "}
              </div>
            )}
            {/* Arrow up/down */}
          </button>
          {allTags &&
            allTags.map((item, index) => (
              <div
                style={{
                  borderBottom: "1px solid var(--light-grey)",
                  padding: "12px",
                  fontSize: "14px",
                }}
                key={index}
                className="c-pointer d-flex align-items-center pin-hover-home"
                onClick={() => {
                  setCenter({
                    lat: item?.pins[0]?.lat,
                    lng: item?.pins[0]?.lng,
                  });
                  setMapZoom(17);
                }}
              >
                <p className="ms-2">{item.name}</p>
              </div>
            ))}
        </div>
        <div
          style={{
            height: expandCategories === true ? "auto" : "25px",
          }}
          className=" mt-4 bxShadow hmap-cont1"
        >
          <button
            className="toggle-button w100 fw-600"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginRight: "8px",
            }}
            onClick={() => setExpandCategories((prev) => !prev)}
          >
            {expandCategories ? (
              <div className="d-flex align-items-center justify-content-center ">
                Categories <ArrowUpwardIcon style={{ width: "18px" }} />
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center">
                {" "}
                Categories <ArrowDownwardIcon style={{ width: "18px" }} />
              </div>
            )}
            {/* Arrow up/down */}
          </button>
          {categories &&
            categories.map((item, index) => (
              <div
                style={{
                  borderBottom: "1px solid var(--light-grey)",
                  padding: "12px",
                  fontSize: "14px",
                }}
                className="c-pointer d-flex align-items-center pin-hover-home"
                key={index}
                onClick={() => getCategories(item.value)}
              >
                <p className="ms-2">{item.label}</p>
              </div>
            ))}
        </div>
        <div
          className="d-flex align-items-center justify-content-center mapserach bxShadow mx-auto p-2 w40"
          style={{
            background: "#FFF",
            position: "relative",
            zIndex: 1000,
            top: 32,
            borderRadius: 8,
            gap: 18,
          }}
        >
          <div className="searchbox w100">
            <MapSearch
              onPlaceSelect={handlePlaceSelect}
              onselect={(id) => setPlaceId(id)}
            />
          </div>
          <SearchIcon
            style={{ paddingRight: "10px", color: "var(--grey-color)" }}
          />
        </div>

        <DirectionsMapComp
          styles={{ height: "40rem" }}
          zoom={mapZoom}
          searchLocation={center}
          markerData={pins || []}
          showDirections={true}
          url={location?.pathname}
          disablePinsMarking={false}
          loading={loader}
          placeDetails={placeId}
        />
      </div>
      {featuredtrips.length > 3 && (
        <>
          {" "}
          <h2 className="mt-5 t-center">Featured Trips</h2>
          <div className="homecont pb-5">
            <SliderComp
              slideNum={4}
              data={featuredtrips}
              autoplay={true}
              autoplaySpeed={3000}
              onItemClick={handleFeaturedTripClick}
            />
          </div>
        </>
      )}
      <h2 className="mt-5 mb-4 pb-4 t-center">
        Choose the Right{" "}
        <span style={{ color: "var(--primary-color)" }}> Membership </span> for
        you
      </h2>
      <div
        className={`d-flex align-items-center  justify-content-center flex-wrap mb-4 p pb-3 ${
          plans.length === 4 ? "w80" : "w70"
        } `}
        style={{ gap: 20, margin: "auto" }}
      >
        {plans.map((mdata) => (
          <div
            key={mdata._id} // Added key here for the outer div
            className="membership-card "
            style={{
              maxWidth: plans.length === 3 ? "33.33%" : "23.33%",
            }}
          >
            <h4
              className="t-center p-3"
              style={{
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                background:
                  mdata?.activePlan === true
                    ? "var(--primary-color)"
                    : mdata.value === "leisure"
                    ? "#FFD35A"
                    : mdata.value === "vip"
                    ? "#EE86A7"
                    : mdata.value === "corporate"
                    ? "#636AE8"
                    : "#FF5C5C",
              }}
            >
              {mdata?.activePlan === true && "Active"}
            </h4>
            <div
              className="boxShadow"
              style={{
                padding: "10px 25px",
              }}
            >
              <div>
                <h2 className="t-center">{mdata?.planName}</h2>
                <p className="t-center fs-8">{mdata?.dscp}</p>
                <div className="my-3 t-center">
                  {mdata.value === "leisure" ? (
                    <h2>Free</h2>
                  ) : (
                    <h2>
                      ${mdata.price}{" "}
                      <span className="fs-8">/{mdata.duration}</span>
                    </h2>
                  )}
                </div>
                {mdata.perks.map((pdata, index) => (
                  <div className="d-flex align-items-start my-2" key={index}>
                    <p>
                      {pdata.status === false ? (
                        <CancelIcon sx={{ width: "18px", color: "#FF2400" }} />
                      ) : (
                        <CheckCircleOutlineIcon
                          sx={{
                            width: "20px",
                            height: "20px",
                            color: "var(--primary-color)",
                          }}
                        />
                      )}
                    </p>
                    <p className="ms-2 fs-8">{pdata?.description}</p>
                  </div>
                ))}
              </div>
              {mdata.value === "leisure" &&
              mdata?.activePlan === "notLoggedIn" ? (
                <button
                  className={`btn-outlined w100 btn-${mdata?.id} ${
                    mdata?.activePlan === true
                      ? "hover-style-active"
                      : mdata.value === "leisure"
                      ? "hover-style-1"
                      : mdata.value === "vip"
                      ? "hover-style-2"
                      : mdata.value === "corporate"
                      ? "hover-style-3"
                      : "hover-style-5"
                  }`}
                  onClick={() => upgradeSubscription(mdata)}
                >
                  Join Now
                </button>
              ) : mdata.value === "leisure" && mdata?.activePlan ? (
                <></>
              ) : (
                <button
                  className={`btn-outlined w100 btn-${mdata?.id} ${
                    mdata?.activePlan === true
                      ? "hover-style-active"
                      : mdata.value === "leisure"
                      ? "hover-style-1"
                      : mdata.value === "vip"
                      ? "hover-style-2"
                      : mdata.value === "corporate"
                      ? "hover-style-3"
                      : "hover-style-5"
                  }`}
                  onClick={() => upgradeSubscription(mdata)}
                >
                  {mdata?.activePlan === "notLoggedIn" ? (
                    "Join Now"
                  ) : mdata?.activePlan === true ? (
                    <>Cancel</>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      {" "}
                      Upgrade{" "}
                      {btnloder && selectedId.value === mdata.value && (
                        <Spinner />
                      )}
                    </div>
                  )}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <h2 className=" t-center mt-5">About US</h2>
      <div className="homecont pb-5">
        <div
          className="row bxShadow p-0 m-0"
          style={{ borderRadius: "8px", background: "var(--white-color)" }}
        >
          <div className="col-md-8 p-4">
            <h2 className="px-3">About Sevenly Travel </h2>
            {/* <h2 className="px-3">Trips</h2> */}
            <hr
              className="ms-3 my-3"
              style={{
                border: "none",
                height: "2px",
                backgroundColor: "var(--primary-color)",
                width: "30%",
              }}
            />
            {/* <h4 className="px-3 my-2">Commodo dolore aliqua</h4> */}
            <p className="px-3 justify-text">
              Welcome to Sevenly Travel! We are dedicated to making your travel
              experience effortless and memorable. Whether you’re planning a
              weekend getaway or a grand adventure, our platform helps you find
              the best destinations and hotels tailored to your preferences.
            </p>
            <h2 className="px-3 my-2 mt-4">Why Choose Us?</h2>
            <hr
              className="ms-3 my-3"
              style={{
                border: "none",
                height: "2px",
                backgroundColor: "var(--primary-color)",
                width: "20%",
              }}
            />
            <p className="px-3">
              ● Personalized Travel Plans: Tailored itineraries to suit your
              style and needs.
            </p>
            <p className="px-3">
              ● Exclusive Hotel Deals: Enjoy special rates on top hotels.
            </p>
            <p className="px-3">
              ● Seamless Planning: Integrate all your travel itinerates into one
              platform. From adding your flight details to building your day to
              day itinerary by pinning your favorite activities.
            </p>
            <h2 className="px-3 mt-4">
              Join us at{" "}
              <span style={{ color: "var(--primary-color)" }}>
                Sevenly Travel{" "}
              </span>
              , where your perfect{" "}
              <span style={{ color: "var(--yellow-color)" }}> trip</span>{" "}
              awaits!
            </h2>
          </div>
          <div className="col-md-4  p-0 m-0 d-flex align-items-center justify-content-center">
            <img
              src={AboutUs}
              className="w100 "
              style={{ borderRadius: "8px" }}
              loading="lazy"
              alt=""
            />
          </div>
        </div>
      </div>
      {/* <h2 className="mt-5 t-center">
        Discover Your{" "}
        <span style={{ color: "var(--primary-color)" }}>Ideal Trip </span>
      </h2>
      <p className="t-center">
        Which of the following best describes you as a traveler?
      </p>
      <div className="homecont ">
        <div ref={questionnairesRef}>
          <div className="row ">
            <div className=" col-md-3 card-container ">
              <div className="card bxShadow">
                <div
                  className="card-front"
                  style={{
                    backgroundImage: `url(${IMGGR1})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="gradient-overlay bxShadow">
                    <h2 className="p-3" style={{ color: "var(--white-color)" }}>
                      {cards[0].title}
                    </h2>
                    <div className="p-3" style={{ textAlign: "end" }}>
                      <button className="btn-contained">
                        {cards[0].buttonText}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-back">
                  <div>
                    <h2
                      className="p-2 ms-2"
                      style={{ color: "var(--primary-color)" }}
                    >
                      {cards[0].title}
                    </h2>
                    <p className="mt-4 p-3">{cards[0].backContent}</p>
                  </div>
                  <div className="w100" style={{ textAlign: "end" }}>
                    <button
                      className="btn-contained mb-3 me-3"
                      onClick={() => handleOpenQuestionsPopUp(cards[0])}
                    >
                      {cards[0].buttonText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-md-6">
              <div className="card-container" style={{ height: "15rem" }}>
                <div className="card bxShadow ">
                  <div
                    className="card-front"
                    style={{
                      backgroundImage: `url(${IMGGR2})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="gradient-overlay bxShadow">
                      <h2
                        className="p-3"
                        style={{ color: "var(--white-color)" }}
                      >
                        {cards[1].title}
                      </h2>
                      <div className="p-3" style={{ textAlign: "end" }}>
                        <button className="btn-contained">
                          {cards[1].buttonText}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-back">
                    <div>
                      <h2
                        className="p-3"
                        style={{ color: "var(--primary-color)" }}
                      >
                        {cards[1].title}
                      </h2>
                      <p className="px-3">{cards[0].backContent}</p>
                    </div>
                    <div className="w100" style={{ textAlign: "end" }}>
                      <button
                        className="btn-contained mb-3 me-3"
                        onClick={() => handleOpenQuestionsPopUp(cards[1])}
                      >
                        {cards[1].buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-container mt-4" style={{ height: "15rem" }}>
                <div className="card mb-2 bxShadow">
                  <div
                    className="card-front"
                    style={{
                      backgroundImage: `url(${IMGGR3})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="gradient-overlay bxShadow">
                      <h2
                        className="p-3"
                        style={{ color: "var(--white-color)" }}
                      >
                        {cards[2].title}
                      </h2>
                      <div className="p-3" style={{ textAlign: "end" }}>
                        <button className="btn-contained">
                          {cards[2].buttonText}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-back">
                    <div>
                      <h2
                        className="p-3"
                        style={{ color: "var(--primary-color)" }}
                      >
                        {cards[2].title}
                      </h2>
                      <p className="px-3">{cards[2].backContent}</p>
                    </div>
                    <div className="w100" style={{ textAlign: "end" }}>
                      <button
                        className="btn-contained mb-3 me-3"
                        onClick={() => handleOpenQuestionsPopUp(cards[2])}
                      >
                        {cards[0].buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-md-3  ">
              <div className="card-container">
                <div className="card bxShadow">
                  <div
                    className="card-front"
                    style={{ backgroundImage: `url(${IMGGR4})` }}
                  >
                    <div className="gradient-overlay bxShadow">
                      <h2
                        className="p-3"
                        style={{ color: "var(--white-color)" }}
                      >
                        {cards[3].title}
                      </h2>
                      <div className="p-3" style={{ textAlign: "end" }}>
                        <button className="btn-contained">
                          {cards[3].buttonText}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-back">
                    <div>
                      <h2
                        className="p-3"
                        style={{ color: "var(--primary-color)" }}
                      >
                        {cards[3].title}
                      </h2>
                      <p className="px-3">{cards[3].backContent}</p>
                    </div>
                    <div className="p-3 w100" style={{ textAlign: "end" }}>
                      <button
                        className="btn-contained me-3 mb-2"
                        onClick={() => handleOpenQuestionsPopUp(cards[3])}
                      >
                        {cards[3].buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {expanded && (
            <div
              className="row mt-4"
              style={{
                maxHeight: expanded
                  ? `${questionnairesRef.current?.scrollHeight}px`
                  : "0",
                overflow: "hidden",
                transition: "all 0.6s ease",
              }}
            >
              <div className=" col-md-6  ">
                <div className="card-container" style={{ height: "20rem" }}>
                  <div className="card bxShadow">
                    <div
                      className="card-front"
                      style={{
                        backgroundImage: `url(${IMGGR5})`,
                      }}
                    >
                      <div className="gradient-overlay bxShadow">
                        <h2
                          className="p-3"
                          style={{ color: "var(--white-color)" }}
                        >
                          {cards[4].title}
                        </h2>
                        <div className="p-3" style={{ textAlign: "end" }}>
                          <button className="btn-contained">
                            {cards[4].buttonText}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-back">
                      <div>
                        <h2
                          className="p-3"
                          style={{ color: "var(--primary-color)" }}
                        >
                          {cards[0].title}
                        </h2>
                        <p className="mt-3 p-3">{cards[4].backContent}</p>
                      </div>
                      <div
                        className="p-3 me-5 w100"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn-contained"
                          onClick={() => handleOpenQuestionsPopUp(cards[4])}
                        >
                          {cards[4].buttonText}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-md-6  ">
                <div className="card-container" style={{ height: "20rem" }}>
                  <div className="card bxShadow">
                    <div
                      className="card-front"
                      style={{
                        backgroundImage: `url(${IMGGR6})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div className="gradient-overlay bxShadow">
                        <h2
                          className="p-3"
                          style={{ color: "var(--white-color)" }}
                        >
                          {cards[5].title}
                        </h2>
                        <div className="p-3" style={{ textAlign: "end" }}>
                          <button className="btn-contained">
                            {cards[5].buttonText}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-back">
                      <div>
                        <h2
                          className="p-3"
                          style={{ color: "var(--primary-color)" }}
                        >
                          {cards[5].title}
                        </h2>
                        <p className="mt-2 p-3">{cards[5].backContent}</p>
                      </div>
                      <div
                        className="p-3 me-5 w100"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn-contained"
                          onClick={() => handleOpenQuestionsPopUp(cards[5].id)}
                        >
                          {cards[0].buttonText}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-center w100 mt-3">
          <button className="btn-outlined t-center " onClick={toggleHeight}>
            {expanded ? "View less" : "View more"}
          </button>
        </div>
      </div> */}
      {/* <Modal
        open={openPopUp}
        onClose={handleClose}
        title={"Questionnaires"}
        children={questionBody()}
        size={"lg"}
      /> */}
      <TripModal
        selectedTrip={selectedFtrip}
        open={openftrip}
        handleClose={handleClose}
      />
      <Modal
        open={subOpen}
        onClose={() => {
          setSubOpen(false);
          setSelectedId(null);
        }}
        title="Cancel Subscription"
        size="sm"
      >
        <p className="mt-4">
          Are you sure you want to cancel the subscription?
        </p>
        <div
          className="mt-4 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button
            className="btn-outlined"
            onClick={() => {
              setSubOpen(false);
              setSelectedId(null);
            }}
          >
            Cancel
          </button>
          <button className="btn-contained d-flex" onClick={cancelSubscription}>
            Confirm {btnloder && <Spinner />}
          </button>
        </div>
      </Modal>
      <Modal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        title="Subscription Payment"
        size="sm"
      >
        <div className="row p-2">
          <div
            className="col-md-12 bxShadow py-3  "
            style={{ borderRadius: "8px" }}
          >
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutSubscriptionForm
                planName={selectedId}
                onSuccess={onPaymentSuccess}
              />
            </Elements>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const cards = [
  {
    title: "The Nature Enthusiast",
    buttonText: "Personalize",
    images: IMGGR1,
    backContent:
      "You thrive in the great outdoors, finding peace and joy in the beauty of nature. Whether it’s hiking through lush forests, camping under the stars, or watching wildlife in their natural habitat, you feel most alive when surrounded by the wonders of the natural world.",
    bgColor: "#FF6347",
  },
  {
    title: "The Cultural Connoisseur",
    buttonText: "Personalize",
    images: IMGGR2,
    backContent:
      " Your travels are a journey of the mind and soul. You seek out museums, art galleries, and historical sites, and you love taking classes to learn something new. For you, every trip is an opportunity to expand your knowledge and immerse yourself in the rich tapestry of human culture.",
    bgColor: "#32CD32",
  },
  {
    title: "The Adventurer",
    buttonText: "Personalize",
    images: IMGGR3,
    backContent:
      " Adrenaline is your best travel companion. You crave the thrill of extreme sports and daring activities. From skydiving and bungee jumping to white-water rafting and mountain climbing, you are always on the lookout for your next heart-pounding adventure.",
    bgColor: "#1E90FF",
  },
  {
    title: "The Hidden Gem Hunter",
    buttonText: "Personalize",
    images: IMGGR4,
    backContent:
      "You are an explorer at heart, always seeking out the road less traveled. You delight in discovering hidden gems and off-the-beaten-path destinations that few others have seen. Your travels are filled with unique experiences and the thrill of the unknown.",
    bgColor: "#1E90FF",
  },
  {
    title: "The Spiritual Wanderer",
    buttonText: "Personalize",
    images: IMGGR5,
    backContent:
      "Your journeys are guided by intuition and a quest for inner peace. You seek out earthy, soulful experiences that nourish your spirit. Whether it’s a meditation retreat, a yoga session in a serene setting, or a spiritual pilgrimage, your travels are a path to self-discovery.",
    bgColor: "#1E90FF",
  },
  {
    title: "The Party Starter",
    buttonText: "Personalize",
    images: IMGGR6,
    backContent:
      "You bring the energy and excitement wherever you go! For you, travel is all about having a great time and making unforgettable memories. Whether it’s dancing the night away at the hottest clubs, enjoying vibrant festivals, or finding the best spots for live music and entertainment, you’re always ready to get the party started. Your trips are filled with laughter, fun, and a lively atmosphere that keeps the good times rolling.",
    bgColor: "#1E90FF",
  },
  {
    title: "Bleisure",
    buttonText: "Personalize",
    backContent:
      "Bleisure travellers can be described as individuals who combine leisure with professional business obligations when they travel. ",
    bgColor: "#1E90FF",
  },
];

const questions = [
  // {
  //   id: 1,
  //   question:
  //     "What factors are most important to you when choosing a travel destination?",
  //   answers: [
  //     { id: 1, option: "Natural beauty and outdoor activities" },
  //     { id: 2, option: "Cultural and historical significance" },
  //     { id: 3, option: "Adventure and thrill opportunities" },
  //     { id: 4, option: "Unique and undiscovered locations" },
  //     { id: 5, option: "Spiritual and wellness experiences" },
  //     { id: 6, option: "Local culture and traditions" },
  //   ],
  // },
  {
    id: 2,
    question: "What type of accommodation do you prefer?",
    answers: [
      { id: 1, option: "Eco-friendly lodges and campsites" },
      { id: 2, option: "Boutique hotels and cultural homestays" },
      { id: 3, option: "Adventure resorts and activity-based accommodations" },
      { id: 4, option: "Remote cabins and unique stays" },
      { id: 5, option: "Wellness retreats and spiritual centers" },
      { id: 6, option: "Local guesthouses and traditional inns" },
    ],
  },
  // {
  //   id: 3,
  //   question: "What activities do you enjoy the most while traveling?",
  //   answers: [
  //     { id: 1, option: "Hiking, camping, and wildlife watching" },
  //     { id: 2, option: "Attending workshops, lectures, and visiting museums" },
  //     { id: 3, option: "Skydiving, bungee jumping, and extreme sports" },
  //     {
  //       id: 4,
  //       option: "Exploring remote areas, trekking, and discovering new places",
  //     },
  //     { id: 5, option: "Meditation, yoga retreats, and spiritual journeys" },
  //     {
  //       id: 6,
  //       option:
  //         "Participating in local festivals, cooking classes, and cultural tours",
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   question:
  //     "How quickly do you like to move from one destination to another?",
  //   answers: [
  //     {
  //       id: 1,
  //       option:
  //         "I prefer to stay in one place for an extended period to fully immerse myself.",
  //     },
  //     {
  //       id: 2,
  //       option:
  //         "I like a balanced pace, spending a few days at each destination.",
  //     },
  //     {
  //       id: 3,
  //       option:
  //         "I enjoy a fast-paced trip, visiting multiple destinations in a short time.",
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   question: " Who will accompany you on this trip?",
  //   answers: [
  //     {
  //       id: 1,
  //       option: "Alone (Me, myself, and I)",
  //     },
  //     {
  //       id: 2,
  //       option: "With a partner ",
  //     },
  //     {
  //       id: 3,
  //       option: "With family ",
  //     },
  //   ],
  // },
  {
    id: 6,
    question:
      " What is your trip budget? (Select the one that most applies to the upper limit of your budget)",
    answers: [
      {
        id: 1,
        option:
          "Budget Travel: Average Daily Cost: $50 - $150. Includes: Budget accommodations (hostels, budget hotels). Keep in mind as you plan your trip, dining at inexpensive restaurants or street foods, public transportation, and free or low-cost activities are the best bet to keep within your budget.",
      },
      {
        id: 2,
        option:
          "Mid-Range Travel: Average Daily Cost: $150 - $500. Includes: Mid-range hotels or vacation rentals. Keep in mind as you plan your trip, dining at mid-range restaurants, occasional taxis or car rentals, and a mix of free and paid activities are the best bet to keep within your budget. ",
      },
      {
        id: 3,
        option:
          "Luxury Travel:  Average Daily Cost: $600 and above. Includes: Luxury hotels or resorts.  Keep in mind as you plan your trip fine dining, private transportation, and premium activities or tours are great choices.  ",
      },
    ],
  },
];

const categories = [
  { id: 1, label: " 𖦹 All", value: "" },
  { id: 2, label: " 🛌🏾 Stays", value: "hotel" },
  { id: 3, label: " 🎨 Culture", value: "museum" },
  { id: 4, label: " 📌 Landmarks", value: "tourist_attraction" },
  { id: 5, label: " ⛺ Outdoors", value: "park" },
  { id: 6, label: " 🍕 Eat", value: "restaurant" },
  { id: 7, label: " 🍸 Drink", value: "bar" },
  { id: 8, label: " ☕ Cafe", value: "cafe" },
  { id: 9, label: " 🛍️ Shop", value: "department_store" },
  { id: 10, label: " 🚕 Transport", value: "airport" },
  { id: 11, label: " 🏬 Amenities", value: "parking" },
  { id: 12, label: " 🏬 Clear Pins", value: "clear" },
];
